import { Divider, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

const DemoAccountSymbol = ({ isShow = false }) => {
  const { t } = useTranslation();
  if (!isShow) return null;
  return (
    <>
      <Divider
        orientation="vertical"
        sx={{
          borderColor: "#999",
          height: "24px",
          paddingLeft: "16px",
          marginTop: "7px !important",
        }}
      />
      <Typography
        sx={{
          color: "var(--global-green-green-6, #00BB7E)",
          textTransform: "uppercase",
          fontSize: "var(--title-t1-20-regular-size, 20px)",
          paddingTop: "7px",
          paddingLeft: "14px",
        }}
      >
        {t("header_demo_account")}
      </Typography>
    </>
  );
};

export default DemoAccountSymbol;
